import { render, staticRenderFns } from "./MobileAccessAdmin.vue?vue&type=template&id=bcb36636&scoped=true"
import script from "./MobileAccessAdmin.vue?vue&type=script&lang=js"
export * from "./MobileAccessAdmin.vue?vue&type=script&lang=js"
import style0 from "./MobileAccessAdmin.vue?vue&type=style&index=0&id=bcb36636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb36636",
  null
  
)

export default component.exports